import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { trendingSearches, trendingCollections, updateSearchAria } from "../helpers"

export default function History() {
    const historyItems = useAppStateSelector(state => state.historyItems)

    // if (!historyItems || !historyItems.length) {
    //     return
    // }
    useEffect(()=>{
        if(window.nostojs){
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ "ns-autocomplete-rec" ])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    // Update Aria
    useEffect(() => {
        updateSearchAria('history');
        return () => updateSearchAria(null); 
    }, []);

    console.log("window.nostoTrendingCollections: ", window.nostoTrendingCollections)

    return (
        <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-align-items-start ns-background-white ns-border-box ns-mx-auto" role="region" aria-live="polite" id="nosto-history-container">
            <div class="ns-w-100 ns-mt-sm-auto ns-autocomplete-section">
                <p class="sr-only" aria-live="assertive">Trending Collections, Products, Searches</p>
                {trendingCollections && 
                <>
                    <h2 
                        class="ns-color-black ns-font-medium ns-autocomplete-heading"
                        tabIndex="0"
                    >
                        TRENDING COLLECTIONS
                    </h2>
                    <div>
                        {(window.nostoTrendingCollections || trendingCollections).map((item, index) => (
                                <a 
                                    class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-3 ns-py-md-2 ns-font-5" 
                                    href={item?.url}
                                    tabIndex="0"
                                    aria-label={`Trending collection: ${item?.name}`}
                                >
                                    {item?.name}
                                </a>
                        ))}
                    </div>
                </>}
            </div>
            <div class="ns-w-100 ns-autocomplete-section">
                <h2 
                    class="ns-color-black ns-font-medium ns-autocomplete-heading"
                    tabIndex="0"
                >
                   TRENDING PRODUCTS
                </h2>
                <div class="nosto_element" id="ns-autocomplete-rec"></div>
            </div>
           {trendingSearches && <div class="ns-top-categories">
                <h2 
                    class="ns-color-black ns-font-medium ns-pb-3 ns-pb-md-2 ns-autocomplete-heading"
                    tabIndex="0"
                >
                    TRENDING SEARCHES
                </h2>
                <div class="ns-d-flex ns-flex-column">
                    {(window.nostoTrendingSearches || trendingSearches).map((item, index)=>{
                        return (
                            <a 
                                href={item?.url} 
                                class="ns-top-category ns-d-block ns-py-3 ns-py-md-2 ns-font-5"
                                tabIndex="0"
                                aria-label={`Trending search: ${item?.name}`}
                            >
                                {item?.name}
                            </a>
                        )
                    })}        
                </div>
            </div>}
        </div>
    )
}

// version commented on October 2nd to adapt code for ADA compliance



// import { defaultConfig } from "../config"
// import { HistoryElement, useAppStateSelector } from "@nosto/preact"
// import { useEffect } from "preact/hooks"
// import { trendingSearches, trendingCollections, updateSearchAria } from "../helpers"

// export default function History() {
//     const historyItems = useAppStateSelector(state => state.historyItems)

//     // if (!historyItems || !historyItems.length) {
//     //     return
//     // }
//     useEffect(()=>{
//         if(window.nostojs){
//             window.nostojs(api => {
//                 api
//                 .createRecommendationRequest({ includeTagging: true })
//                 .setElements([ "ns-autocomplete-rec" ])
//                 .load({ skipPageViews: true, skipEvents: true })
//             })
//         }
//     }, [])

//     // Update Aria
//     useEffect(() => {
//         updateSearchAria('history');
//         return () => updateSearchAria(null); 
//     }, []);

//     console.log("window.nostoTrendingCollections: ", window.nostoTrendingCollections)

//     return (
//         <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-align-items-start ns-background-white ns-border-box ns-mx-auto" role="region" aria-live="polite" id="nosto-history-container">
//             <div class="ns-w-100 ns-mt-sm-auto ns-autocomplete-section">
//                 <p class="sr-only" aria-live="assertive">Trending Collections, Products, Searches</p>
//                 {trendingCollections && 
//                 <>
//                     <div 
//                         class="ns-color-black ns-font-medium ns-autocomplete-heading"
//                         tabIndex="0"
//                         role="heading"
//                         aria-level="2"
//                     >
//                         TRENDING COLLECTIONS
//                     </div>
//                     <div>
//                         {(window.nostoTrendingCollections || trendingCollections).map(item => (
//                                 <a class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-3 ns-py-md-2 ns-font-5" href={item?.url}>
//                                     {item?.name}
//                                 </a>
//                         ))}
//                     </div>
//                 </>}
//             </div>
//             <div class="ns-w-100 ns-autocomplete-section">
//                 <div 
//                     class="ns-color-black ns-font-medium ns-autocomplete-heading"
//                     tabIndex="0"
//                     role="heading"
//                     aria-level="2"
//                 >
//                    TRENDING PRODUCTS
//                 </div>
//                 <div class="nosto_element" id="ns-autocomplete-rec"></div>
//             </div>
//            {trendingSearches && <div class="ns-top-categories">
//                 <div 
//                     class="ns-color-black ns-font-medium ns-pb-3 ns-pb-md-2 ns-autocomplete-heading"
//                     tabIndex="0"
//                     role="heading"
//                     aria-level="2"
//                 >
//                     TRENDING SEARCHES
//                 </div>
//                 <div class="ns-d-flex ns-flex-column">
//                     {(window.nostoTrendingSearches || trendingSearches).map((item, index)=>{
//                         return (
//                             <a href={item?.url} class="ns-top-category ns-d-block ns-py-3 ns-py-md-2 ns-font-5">{item?.name}</a>
//                         )
//                     })}        
//                 </div>
//             </div>}
//         </div>
//     )
// }

// Initial

// import { defaultConfig } from "../config"
// import { HistoryElement, useAppStateSelector } from "@nosto/preact"
// import { useEffect } from "preact/hooks"
// import { trendingSearches, trendingCollections } from "../helpers"

// export default function History() {
//     const historyItems = useAppStateSelector(state => state.historyItems)

//     if (!historyItems || !historyItems.length) {
//         return
//     }
//     useEffect(()=>{
//         if(window.nostojs){
//             window.nostojs(api => {
//                 api
//                 .createRecommendationRequest({ includeTagging: true })
//                 .setElements([ "ns-autocomplete-rec" ])
//                 .load({ skipPageViews: true, skipEvents: true })
//             })
//         }
//     }, [])

//     return (
//         <div class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-align-items-start ns-background-white ns-border-box ns-mx-auto">
//             <div class="ns-w-100 ns-mt-sm-auto ns-autocomplete-section">
//                 {trendingCollections && 
//                 <>
//                     <div class="ns-color-black ns-font-medium ns-autocomplete-heading">
//                         TRENDING COLLECTIONS
//                     </div>
//                     <div>
//                         {(window.nostoTrendingCollections || trendingCollections).map(item => (
//                                 <div class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-3 ns-py-md-2 ns-font-5" onClick={() => {window.location.href = item?.url}}>
//                                     {item?.name}
//                                 </div>
//                         ))}
//                     </div>
//                 </>}
//             </div>
//             <div class="ns-w-100 ns-autocomplete-section">
//                 <div class="ns-color-black ns-font-medium ns-autocomplete-heading">
//                    TRENDING PRODUCTS
//                 </div>
//                 <div class="nosto_element" id="ns-autocomplete-rec"></div>
//             </div>
//            {trendingSearches && <div class="ns-top-categories">
//                 <div class="ns-color-black ns-font-medium ns-pb-3 ns-pb-md-2 ns-autocomplete-heading">
//                     TRENDING SEARCHES
//                 </div>
//                 <div class="ns-d-flex ns-flex-column">
//                     {(window.nostoTrendingSearches || trendingSearches).map((item, index)=>{
//                         return (
//                             <a href={item?.url} class="ns-top-category ns-d-block ns-py-3 ns-py-md-2 ns-font-5">{item?.name}</a>
//                         )
//                     })}        
//                 </div>
//             </div>}
//         </div>
//     )
// }

// ADA version 1

// import { defaultConfig } from "../config"
// import { HistoryElement, useAppStateSelector } from "@nosto/preact"
// import { useEffect, useRef, useState } from "preact/hooks"
// import { trendingSearches, trendingCollections } from "../helpers"

// export default function History() {
//     const historyItems = useAppStateSelector(state => state.historyItems)
//     const historyRef = useRef(null)
//     const [focusedIndex, setFocusedIndex] = useState(-1)

//     useEffect(() => {
//         if (window.nostojs) {
//             window.nostojs(api => {
//                 api
//                     .createRecommendationRequest({ includeTagging: true })
//                     .setElements(["ns-autocomplete-rec"])
//                     .load({ skipPageViews: true, skipEvents: true })
//             })
//         }
//     }, [])

//     useEffect(() => {
//         const handleKeyDown = (event) => {
//             if (event.key === 'Escape') {
        
//             } else if (event.key === 'ArrowDown') {
//                 event.preventDefault()
//                 setFocusedIndex((prevIndex) => (prevIndex < getTotalItems() - 1 ? prevIndex + 1 : prevIndex))
//             } else if (event.key === 'ArrowUp') {
//                 event.preventDefault()
//                 setFocusedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex))
//             }
//         }

//         document.addEventListener('keydown', handleKeyDown)
//         return () => {
//             document.removeEventListener('keydown', handleKeyDown)
//         }
//     }, [])

//     useEffect(() => {
//         if (focusedIndex >= 0) {
//             const items = historyRef.current.querySelectorAll('[role="link"], [role="heading"]')
//             if (items[focusedIndex]) {
//                 items[focusedIndex].focus()
//             }
//         }
//     }, [focusedIndex])

//     const getTotalItems = () => {
//         let totalItems = 0
//         if (trendingCollections) {
//             totalItems += (window.nostoTrendingCollections || trendingCollections).length + 1
//         }
//         if (trendingSearches) {
//             totalItems += (window.nostoTrendingSearches || trendingSearches).length + 1
//         }
        
//         const recItems = document.querySelectorAll('#ns-autocomplete-rec [role="link"]')
//         totalItems += recItems.length + 1
//         return totalItems
//     }

//     if (!historyItems || !historyItems.length) {
//         return null
//     }

//     return (
//         <div
//             ref={historyRef}
//             class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
//             role="region"
//             aria-live="polite"
//             aria-labelledby="history-heading"
//         >
//             <div id="history-heading" class="sr-only">Search History and Trending Items</div>
//             <div class="ns-w-100 ns-mt-sm-auto ns-autocomplete-section">
//                 {trendingCollections &&
//                     <>
//                         <div
//                             class="ns-color-black ns-font-medium ns-autocomplete-heading"
//                             id="trending-collections-heading"
//                             tabIndex="0"
//                             role="heading"
//                             aria-level="2"
//                         >
//                             TRENDING COLLECTIONS
//                         </div>
//                         <div aria-labelledby="trending-collections-heading">
//                             {(window.nostoTrendingCollections || trendingCollections).map((item, index) => (
//                                 <div
//                                     key={index}
//                                     class="ns-autocomplete-element ns-d-flex flex-row ns-justify-content-between ns-clickable ns-py-3 ns-py-md-2 ns-font-5"
//                                     onClick={() => { window.location.href = item?.url }}
//                                     onKeyPress={(e) => { if (e.key === 'Enter') window.location.href = item?.url }}
//                                     tabIndex="0"
//                                     role="link"
//                                     aria-label={`Trending Collection: ${item?.name}`}
//                                 >
//                                     {item?.name}
//                                 </div>
//                             ))}
//                         </div>
//                     </>
//                 }
//             </div>
//             <div class="ns-w-100 ns-autocomplete-section">
//                 <div
//                     class="ns-color-black ns-font-medium ns-autocomplete-heading"
//                     id="trending-products-heading"
//                     tabIndex="0"
//                     role="heading"
//                     aria-level="2"
//                 >
//                     TRENDING PRODUCTS
//                 </div>
//                 <div class="nosto_element" id="ns-autocomplete-rec" aria-labelledby="trending-products-heading"></div>
//             </div>
//             {trendingSearches &&
//                 <div class="ns-top-categories" aria-labelledby="trending-searches-heading">
//                     <div
//                         class="ns-color-black ns-font-medium ns-pb-3 ns-pb-md-2 ns-autocomplete-heading"
//                         id="trending-searches-heading"
//                         tabIndex="0"
//                         role="heading"
//                         aria-level="2"
//                     >
//                         TRENDING SEARCHES
//                     </div>
//                     <div class="ns-d-flex ns-flex-column">
//                         {(window.nostoTrendingSearches || trendingSearches).map((item, index) => (
//                             <a
//                                 key={index}
//                                 href={item?.url}
//                                 class="ns-top-category ns-d-block ns-py-3 ns-py-md-2 ns-font-5"
//                                 aria-label={`Trending Search: ${item?.name}`}
//                                 tabIndex="0"
//                                 role="link"
//                                 onClick={() => { window.location.href = item?.url }}
//                                 onKeyPress={(e) => { if (e.key === 'Enter') window.location.href = item?.url }}
//                             >
//                                 {item?.name}
//                             </a>
//                         ))}
//                     </div>
//                 </div>
//             }
//         </div>
//     )
// }